import styled from 'styled-components';

export const Container = styled.div`
  background: #000;
  padding: 20px 20px;
  padding-bottom: 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const LogoWrapper = styled.div`
  width: 100%;

  @media screen and (max-width: 767px) {
    margin-bottom: 30px;
  }
`;

export const Logo = styled.img`
  max-width: 150px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

export const AddressColumnLeft = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-right: 60px;

  @media screen and (max-width: 767px) {
    margin-bottom: 10px;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;

  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const FooterRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 50px;
  padding: 0 100px;

  @media screen and (max-width: 767px) {
    flex-direction: column;
    padding: 0 30px;
    margin-top: 0;
  }
`;

export const MenuItem = styled.span`
  font-family: IBMPlexSans;
  font-weight: normal;
  font-size: 18.817px;
  line-height: 25px;
  color: #FFFFFF;
  margin-bottom: 18px;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
`;

export const EmailLabel = styled.div`
  font-family: IBMPlexSansBold;
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  color: #FFFFFF;

  @media screen and (max-width: 767px) {
    margin-top: 20px;
  }
`;

export const Email = styled.div`
  font-family: IBMPlexSans;
  font-size: 18.817px;
  line-height: 29px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
`;

export const EmailIcon = styled.img`
  margin-right: 11.5px;
  width: 24px;
`;

export const FooterLogoWrapper = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

export const ContactWrapper = styled.div``;

export const AddressTitle = styled.div`
  font-family: IBMPlexSans;
  font-style: normal;
  font-weight: bold;
  font-size: 25.0893px;
  line-height: 150%;
  color: #FFFFFF;
  margin-bottom: 22.37px;

  @media screen and (max-width: 767px) {
    margin-top: 30px;
  }
`;

export const Address = styled.span`
  font-family: IBMPlexSans;
  font-size: 13px;
  line-height: 24px;
  color: #FFFFFF;
`;

export const Unity = styled.span`
  font-family: IBMPlexSansBold;
  font-weight: 600;
  font-size: 13px;
  line-height: 24px;
  color: #FFFFFF;
`;

export const CopyrightRow = styled.div`
  font-family: IBMPlexSans;
  font-weight: normal;
  font-style: normal;
  font-size: 18.817px;
  line-height: 25px;
  color: #FFFFFF;
  padding: 5px;
  background: #000;

  @media screen and (max-width: 767px) {
    font-size: 12px;
    padding-bottom: 40px;
    width: 100%;
  }
`;
